import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.size || 18}
            height={props.size || 19}
            viewBox="0 0 18 19"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_701_1378)">
                <path
                    d="M13.737 4.763L9.474 4.29l-5.21.474L3.79 9.5l.473 4.737L9 14.829l4.737-.592.474-4.855-.474-4.619z"
                    fill="#fff"
                />
                <path
                    d="M6.206 12.112c-.354-.239-.599-.588-.733-1.05l.822-.339c.075.284.205.505.391.661.185.156.41.233.673.233.269 0 .5-.081.692-.245a.783.783 0 00.29-.624.774.774 0 00-.305-.632c-.204-.164-.46-.245-.765-.245h-.475v-.814h.426c.263 0 .485-.07.665-.213a.703.703 0 00.27-.584c0-.22-.08-.395-.242-.527a.936.936 0 00-.612-.198c-.242 0-.433.064-.576.194-.142.129-.245.287-.31.474l-.813-.338c.107-.306.305-.576.595-.81.29-.232.661-.35 1.111-.35.333 0 .632.064.898.193.265.13.473.308.624.536.15.228.225.484.225.768 0 .29-.07.535-.21.737-.14.201-.311.355-.515.463v.048c.269.113.488.284.66.515.173.231.259.507.259.83 0 .322-.082.61-.245.861-.164.253-.39.452-.676.596a2.131 2.131 0 01-.97.218c-.416.001-.8-.118-1.154-.358zM11.25 8.034l-.898.652-.45-.684 1.618-1.168h.62v5.508h-.89V8.034z"
                    fill="#1A73E8"
                />
                <path
                    d="M13.737 18.5L18 14.237l-2.132-.947-2.131.947-.947 2.131.947 2.132z"
                    fill="#EA4335"
                />
                <path
                    d="M3.316 16.369l.947 2.131h9.474v-4.263H4.263l-.947 2.132z"
                    fill="#34A853"
                />
                <path
                    d="M1.421.5A1.42 1.42 0 000 1.921v12.316l2.132.947 2.131-.947V4.763h9.474l.947-2.131L13.737.5H1.42z"
                    fill="#4285F4"
                />
                <path
                    d="M0 14.237v2.842A1.42 1.42 0 001.421 18.5h2.842v-4.263H0z"
                    fill="#188038"
                />
                <path
                    d="M13.737 4.763v9.474H18V4.763l-2.132-.947-2.131.947z"
                    fill="#FBBC04"
                />
                <path
                    d="M18 4.763V1.921A1.42 1.42 0 0016.579.5h-2.842v4.263H18z"
                    fill="#1967D2"
                />
            </g>
            <defs>
                <clipPath id="clip0_701_1378">
                    <path
                        fill="#fff"
                        transform="translate(0 .5)"
                        d="M0 0H18V18H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SvgComponent;
